import BrTooltip, { Tooltip, Locations } from './BrTooltip';

BrTooltip.Tooltip = Tooltip;
BrTooltip.Locations = Locations;
export default BrTooltip;
